/*
 * VUEX getters
 */
export const userGetters = {
  getLoggedIn(state) {
    return state.loggedin
  },
  isUserLoggedIn(state) {
    return state.loggedin
  },
  getDisplayName(state) {
    return state.displayName
  },
  getPnr(state) {
    return state.pnr
  },
  getGuardian(state) {
    return state.guardian
  },
  getAddedGuardians(state) {
    return state.addedguardians
  },
  getGuardianInfo(state) {
    return state.guardian
  },
  getChild(state) {
    return state.child
  },
  getChildInformation(state) {
    return state.childInformation
  },
  getFeideUser(state) {
    return state.feideuser
  },
  getAllowedAdmins(state) {
    return state.allowedAdmins
  },
  getAllowedKindergartenAdmins(state) {
    return state.allowedKindergartenAdmins
  },
  getLoginInformation(state) {
    return state.loginInformation
  }
}
